import React, { useEffect, useState } from 'react';
import { useClickStore } from '../store/clickStore';
import { useShallow } from 'zustand/react/shallow';
import DraggablePanel from '../components/ui/DraggablePanel';
import DownholeLog, { holeRecordFromDetails } from '../components/ui/DownholeLog';

export default function ObjectDetails() {
  const { objectDetails, objectDetailsObject, clickType } = useClickStore(
    useShallow((state) => ({
      objectDetails: state.objectDetails,
      objectDetailsObject: state.objectDetailsObject,
      clickType: state.clickType,
    }))
  );

  const [isDetailsVisible, setIsDetailsVisible] = useState(false);

  useEffect(() => {
    if (clickType === 'info' && objectDetails) {
      setIsDetailsVisible(true);
    }
  }, [clickType, objectDetails]);

  if (clickType !== 'info') return null;
  if (!objectDetailsObject || !objectDetails) return null;

  const { holeId } = holeRecordFromDetails(objectDetails);
  const title =
    holeId ||
    objectDetails.Name ||
    objectDetails.ObjectName ||
    objectDetailsObject.name ||
    'Details';
  const entries = Object.entries(objectDetails).slice(0, 24);

  return (
    <DraggablePanel
      id="object-details"
      handleLabel="Details"
      zIndex={1230}
      className="pointer-events-auto"
      style={{ width: holeId ? 'min(22rem, calc(100vw - 1rem))' : 'min(18rem, calc(100vw - 1rem))' }}
    >
      <div className="flex flex-col gap-1.5 rounded-b-md border border-yellow-600/35 border-t-0 bg-zinc-950/95 p-1.5 shadow-[0_12px_40px_rgba(0,0,0,0.5)] backdrop-blur-md">
        <div className="flex items-center justify-between gap-2 px-1">
          <p className="truncate text-[11px] font-semibold text-yellow-400">{title}</p>
          <button
            type="button"
            onClick={() => setIsDetailsVisible((v) => !v)}
            className="m-0 text-[10px] uppercase tracking-wider text-zinc-500 hover:text-yellow-400"
          >
            {isDetailsVisible ? 'Hide' : 'Show'}
          </button>
        </div>

        {isDetailsVisible && (
          <div className="space-y-2">
            {holeId ? <DownholeLog details={objectDetails} compact /> : null}
            <div className="max-h-[min(28vh,12rem)] overflow-hidden rounded-sm border border-yellow-600/25">
              <div className="overflow-y-auto max-h-[min(24vh,10rem)]">
                <table className="w-full text-[10px]">
                  <tbody>
                    {entries.map(([key, value]) => (
                      <tr key={key} className="border-b border-zinc-900/80">
                        <td className="px-2 py-1 align-top text-zinc-500 whitespace-nowrap">{key}</td>
                        <td className="px-2 py-1 text-zinc-200 break-all">{String(value ?? '')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </DraggablePanel>
  );
}
